import React from 'react'
import { Tabs, Tab } from 'shared/ui/Tabs';
import SuppliersList from 'features/parties/components/suppliers/SuppliersList';

const SupplierGroupItem = ({item}) => {
  return (
    <div>
      <Tabs initialTab='suppliers'>
        <Tab key='suppliers' label='Поставщики'>
          <SuppliersList suppliergroup={item} />
        </Tab>
      </Tabs>
    </div>
  )
}

export default SupplierGroupItem